import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeMyAccountPageTranslations } from '@/utils/translations';
import {
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  CTA_NAMES,
} from '@/utils/rudderstack';
import useFeature from '@/hooks/useFeature';
import { getLocaleDomain } from '@/utils/helpers';

export type ReferAFriendTileProps = {
  t: TypeMyAccountPageTranslations;
  userUuid: string;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
  classes?: string | undefined;
};

const ReferAFriendTile: FC<ReferAFriendTileProps> = ({
  t,
  userUuid,
  tile,
  locale,
  classes,
}) => {
  const prismEnabled = useFeature('money-referral-toggle');
  const baseUrl = getLocaleDomain(locale);
  const prismLink = `${baseUrl}/pages/refer-a-friend`;

  const referralLink = prismEnabled
    ? prismLink
    : constructLegacyCustomerPortalLink(locale, [userUuid, 'refer-a-friend']);

  if (
    !prismEnabled &&
    (!process.env.NEXT_PUBLIC_REFERRALS_ENABLED ||
      process.env.NEXT_PUBLIC_REFERRALS_ENABLED === 'false')
  ) {
    return null;
  }

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: referralLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.REFER_A_FRIEND_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      description={tile.description}
      titleDecorator={
        <GenExternalLink
          href={referralLink}
          cta={t.viewCta}
          onClick={sendItemClickedEvent}
        />
      }
      classes={classes}
    />
  );
};

export default React.memo(ReferAFriendTile);
